<div class="d-flex flex-row paginator">
  <div class="arrow-left" (click)="previousPage()">&#10229;</div>
  @for (i of [].constructor(this.pagesPerView); track i; let index = $index) {
    @if (offset+index+1 <= pageCount) {
      <div class="page-number"
        (click)="pageSelect(offset+index+1)"
        [ngClass]="{ 'active' : selectedPage == offset+index+1 }">
        {{ offset+index+1 }}
      </div>
    }
  }
  <div class="arrow-right"
  (click)="nextPage()">&#10230;</div>
</div>
